import { useQuery } from "@apollo/client";
import { matchPath, useLocation } from "react-router";
import { useParams } from "react-router-dom";

import { useAppState } from "core/contexts/AppContext";
import errorParser from "core/includes/errorParser";
import { getURLSegment } from "core/includes/formatters";
import { getCanRenderWebp } from "core/includes/image";
import { retrieveValue } from "core/includes/localStorage";
import pageQuery from "core/includes/queries";

/**
 * Looks at the url and requests the page data from the backend.
 */
const useRouter = (stage: string | null, urlSegmentName?: string) => {
    const location = useLocation();
    const params = useParams();
    const url = urlSegmentName ? params[urlSegmentName] : getURLSegment(location.pathname);
    const [appState] = useAppState();
    const canRenderWebp = getCanRenderWebp();
    const isProfilePage = !!matchPath('/profile', location.pathname);

    let countryCode = appState.countryCode.code;
    countryCode = countryCode === 'other' ? 'au' : countryCode;

    const { data, loading, error } = useQuery(pageQuery, {
        variables: {
            urlSegment: url,
            stage: stage,
            canRenderWebp,
            userId: appState.user?.id,
            countryCode,
        },
        context: {
            headers: {
                'Selected-Country': appState.countryCode.code || (retrieveValue("selected-country")?.replace(/"/g, "") ?? "")
            }
        },
        skip: appState.isSkipLoadingPage || isProfilePage,
    });

    let errorToReturn = null;

    if (error) {
        errorToReturn = errorParser(error);
    }

    let internalPage = null;

    if (isProfilePage) {
        internalPage = "profile";
    }

    return [data, loading, errorToReturn, internalPage];
};

export default useRouter;